import axios from 'axios'
import {Message} from 'element-ui'
import router from '@/router'

// 创建axios实例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API || '/api',
    timeout: 15000,
    withCredentials: true
})

// 响应拦截器
service.interceptors.response.use(
    response => {
        if (response.config.responseType === 'blob') {
            return response
        }
        const res = response.data
        // 成功code = 0
        if (res.code !== 0) {
            // ===== 修复：统一转为数字对比，兼容字符串"1001"/数字1001 =====
            const code = Number(res.code)
            // 登录过期
            if (code === 1001 || code === 1002) {
                Message.warning('登录已过期，请重新登录')
                // 清除本地存储(关键！防止反复弹窗)
                localStorage.clear()
                sessionStorage.clear()
                // 避免重复跳转捕获报错
                if (router.currentRoute.path !== '/login') {
                    router.push('/login').catch(() => {})
                }
            } else if (code === 1003) {
                Message.warning('权限不足，禁止操作')
            } else {
                Message.error(res.message || '请求失败')
            }
            return Promise.reject(res)
        }
        return res
    },
    error => {
        if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
            Message.error('请求超时，请稍后重试')
            return Promise.reject(error)
        }
        if (!error.response) {
            Message.error('无法连接服务，请检查后端服务是否正常启动')
            return Promise.reject(error)
        }
        const errData = error.response?.data || {}
        const errCode = Number(errData.code)
        if (errCode === 1001 || errCode === 1002) {
            Message.warning('登录已过期，请重新登录')
            localStorage.clear()
            sessionStorage.clear()
            if (router.currentRoute.path !== '/login') {
                router.push('/login').catch(() => {})
            }
        } else if (errCode === 1003) {
            Message.warning('权限不足，禁止操作')
        } else {
            Message.error('服务器异常')
        }
        return Promise.reject(error)
    }
)

export default service